/* eslint-disable no-underscore-dangle */
import { fabric } from 'fabric';
import { DEFAULT_SVG_PATH } from '../svgPath';
import LabelRect from '../rectButton';
import { ACTIVE_SELECTION_ID, CUSTOM_GROUP_ID, GROUP, TEXT_GROUP_ID, IMAGE_HTML_ID, IMAGE_ID } from '../constants';
import { generateImageHtmlId, sleep } from '../common';

const DEFAULT_WIDTH = 200;
const DEFAULT_HEIGHT = 150;
export const generateId = () =>
  `_${Math.random()
    .toString(36)
    .substr(2, 9)}`;
export const getObjId = (obj) => {
  let newId = generateId();
  const { id = newId } = obj;
  switch (true) {
    case id.includes(CUSTOM_GROUP_ID):
      newId = `${newId}_${CUSTOM_GROUP_ID}`;
      obj?._objects?.forEach((o) => {
        o.set({ parentId: newId });
      });
      break;
    case id.includes(TEXT_GROUP_ID):
      newId = `${newId}_${TEXT_GROUP_ID}`;
      obj?._objects?.forEach((o) => {
        o.set({ parentId: newId });
      });
      break;
    case id.includes(ACTIVE_SELECTION_ID):
      newId = `${newId}_${ACTIVE_SELECTION_ID}`;
      break;
    case id.includes(IMAGE_HTML_ID):
      newId = generateImageHtmlId(id);
      break;
    case id.includes(IMAGE_ID):
      newId = `${newId}_${IMAGE_ID}`;
      break;
    default:
      break;
  }
  obj.set({ id: newId });
  if (obj.type === GROUP && obj._objects && obj._objects.length) {
    obj._objects.forEach(getObjId);
  }
};
const loadSVGFromString = (strSVG) => {
  let obj;
  fabric.loadSVGFromString(strSVG, (objects, options) => {
    obj = fabric.util.groupSVGElements(objects, options);
  });
  return obj;
};
const textComponent = (data) => {
  const { text = 'Text Here', width = DEFAULT_WIDTH, name = '' } = data;
  return new fabric.Textbox(text, {
    name,
    textAlign: 'left',
    fontFamily: 'Segoe UI',
    fontSize: 12,
    fill: '#000',
    width,
    objectCaching: false,
    isWrapping: false,
    lockMovementX: true,
    lockMovementY: true,
    lockScalingX: true,
    lockScalingY: true,
    listType: 'unorder',
    listBullet: '*',
    listCounter: 0,
    simulateList: false,
    noScaleCache: true,
    ...data,
  });
};
const rectComponent = (data) => {
  const { width, height } = data;
  return new fabric.Rect({
    width,
    height,
    fill: 'transparent',
    strokeWidth: 1,
    stroke: '#000',
    strokeUniform: true,
  });
};
const circleComponent = (data) =>
  new fabric.Circle({
    fill: 'transparent',
    ...data,
  });
const triangleComponent = (data) =>
  new fabric.Triangle({
    fill: 'transparent',
    ...data,
  });
const groupComponent = (components, data) => new fabric.Group(components, data);
export const convertJsonToObject = async (jsonData) => {
  let obj;
  fabric.util.enlivenObjects([jsonData], (enlivenedObjects) => {
    [obj] = enlivenedObjects;
  });
  /* eslint-disable no-await-in-loop */
  let limitTime = 100;
  while (!obj && limitTime > 0) {
    limitTime -= 0.1;
    await sleep(100);
  }
  return obj;
};
export const addRectWithText = (e, rectC = null, textC = null) => {
  const rect = rectC || rectComponent({ width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT, id: generateId() });
  const text =
    textC ||
    textComponent({
      name: 'textRect',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc maximus, nulla ut commodo sagittis',
      width: DEFAULT_WIDTH - 20,
      id: generateId(),
      originX: 'center',
      originY: 'center',
      left: rect.width / 2,
      top: rect.height / 2,
    });
  const components = [rect, text];
  const groupData = {
    left: e.offsetX - DEFAULT_WIDTH / 2 || 0,
    top: e.offsetY - DEFAULT_HEIGHT / 2 || 0,
    id: `${generateId()}_${TEXT_GROUP_ID}`,
    name: 'rect_text_group',
    objectCaching: false,
  };
  const group = groupComponent(components, groupData);
  return group;
};
export const addCircleWithText = (e) => {
  const circle = circleComponent({
    width: DEFAULT_WIDTH,
    height: DEFAULT_WIDTH,
    radius: DEFAULT_WIDTH / 2,
    originX: 'center',
    originY: 'center',
    fill: 'white',
    stroke: 'black',
    strokeWidth: 1,
    id: generateId(),
  });
  const text = textComponent({ name: 'textCircle', width: DEFAULT_WIDTH });
  const components = [circle, text];
  const groupData = {
    left: e.offsetX - DEFAULT_WIDTH / 2 || 0,
    top: e.offsetY - DEFAULT_WIDTH / 2 || 0,
    width: DEFAULT_WIDTH,
    height: DEFAULT_WIDTH,
    id: `${generateId()}_${TEXT_GROUP_ID}`,
    name: 'circle_custop_group',
    hasBorders: false,
  };
  const group = groupComponent(components, groupData);
  return group;
};
export const addTriangelWithText = (e) => {
  const triangel = triangleComponent({
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    stroke: '#000',
    strokeWidth: 1,
    originX: 'center',
    originY: 'center',
    id: generateId(),
    hasBorders: false,
  });
  const text = textComponent({ name: 'textTriangel', width: DEFAULT_WIDTH, top: 50 });
  const components = [triangel, text];
  const groupData = {
    left: e.offsetX - DEFAULT_WIDTH / 2 || 0,
    top: e.offsetY - DEFAULT_HEIGHT / 2 || 0,
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    id: `${generateId()}_${TEXT_GROUP_ID}`,
    name: 'tri_custom_group',
  };
  const group = groupComponent(components, groupData);
  return group;
};

export const addCircle = (e) => {
  const circle = circleComponent({
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    stroke: '#000',
    strokeWidth: 1,
    radius: 50,
    id: generateId(),
  });
  const coord = {
    left: e.offsetX - circle.width / 2 || 0,
    top: e.offsetY - circle.height / 2 || 0,
  };
  circle.set(coord);
  return circle;
};
export const addTriangel = (e, type) => {
  const pathObj = DEFAULT_SVG_PATH[type];
  const circle = triangleComponent({
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    stroke: pathObj.stroke,
    strokeWidth: 1,
    id: generateId(),
  });
  const coord = {
    left: e.offsetX - circle.width / 2 || 0,
    top: e.offsetY - circle.height / 2 || 0,
  };
  circle.set(coord);
  return circle;
};

export const addSVGPath = (e, type) => {
  const pathObj = DEFAULT_SVG_PATH[type];
  const path = new fabric.Path(pathObj.path, {
    fill: pathObj.fill,
    stroke: pathObj.stroke,
    width: pathObj.width,
    height: pathObj.height,
    id: generateId(),
  });
  const coord = {
    left: e.offsetX - path.width / 2 || 0,
    top: e.offsetY - path.height / 2 || 0,
  };
  path.set(coord);
  return path;
};

export const addText = (e) => {
  const str =
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n' +
    'Nunc maximus, nulla ut commodo sagittis, sapien dui mattis dui,\n' +
    'non pulvinar lorem felis nec erat';

  const text = textComponent({
    text: str,
    name: 'textRect',
    width: 200,
    height: 80,
    id: generateId(),
    lockMovementX: false,
    lockMovementY: false,
    lockScalingX: false,
    lockScalingY: false,
  });
  const coord = {
    left: e.offsetX - text.width / 2 || 0,
    top: e.offsetY - text.height / 2 || 0,
  };
  text.set(coord);
  return text;
};
export const addRectButton = (e) => {
  const rect = new LabelRect({
    width: DEFAULT_WIDTH,
    height: 50,
    fill: '#faa',
    label: 'Button',
    isTextable: true,
    rx: 10,
    ry: 10,
    id: generateId(),
  });
  const coord = {
    left: e.offsetX - rect.width / 2 || 0,
    top: e.offsetY - rect.height / 2 || 0,
  };
  rect.set(coord);
  return rect;
};
const getObjFromSVGString = (e, type) => {
  const pathObj = DEFAULT_SVG_PATH[type];
  const obj = loadSVGFromString(pathObj.svg);
  const coord = {
    left: e.offsetX - obj.width / 2 || 0,
    top: e.offsetY - obj.height / 2 || 0,
    id: generateId(),
  };
  obj.set(coord);
  return obj;
};
export const getShapeByType = (e, type) => {
  let obj = null;
  switch (type) {
    case 'circle':
      obj = addCircle(e, 'circle');
      break;
    case 'retangle':
      obj = addRectWithText(e);
      break;
    case 'triangle':
      obj = addTriangel(e, type);
      break;
    case 'cloud':
      obj = addSVGPath(e, type);
      break;
    case 'male_avatar':
      obj = addSVGPath(e, type);
      break;
    case 'text':
      obj = addText(e);
      break;
    case 'rect_button':
      obj = addRectButton(e);
      break;
    case 'circle_with_text':
      obj = addCircleWithText(e);
      break;
    case 'triangel_with_text':
      obj = addTriangelWithText(e);
      break;
    case 'search':
      obj = getObjFromSVGString(e, type);
      break;
    default:
      break;
  }
  return obj;
};

export const getCoords = ({ type, itemWidth, groupWidth, groupHeight, itemHeight, page }) => {
  switch (type) {
    case 'left':
      return {
        left: page.left,
      };
    case 'center':
      return {
        left: groupWidth / 2 - itemWidth / 2,
      };
    case 'right':
      return {
        left: groupWidth - itemWidth - page.left,
      };
    case 'middle':
      return {
        left: groupWidth / 2 - itemWidth / 2,
        top: groupHeight / 2 - itemHeight / 2,
      };
    case 'top':
      return {
        top: page.top,
      };
    case 'bottom':
      return {
        top: groupHeight - itemHeight - page.top,
      };
    default:
      break;
  }
  return null;
};
export const processAlign = (val, canvas) => {
  const cZ = canvas.getZoom();
  const activeObj = canvas.getActiveObject();
  let left;
  let top;
  switch (val) {
    case 'left':
      if (activeObj.angle <= 90) {
        left = activeObj.aCoords.tl.x - activeObj.aCoords.bl.x;
      }
      if (activeObj.angle > 90 && activeObj.angle <= 180) {
        left = activeObj.aCoords.tl.x - activeObj.aCoords.br.x;
      }
      if (activeObj.angle > 180 && activeObj.angle <= 270) {
        left = activeObj.aCoords.tl.x - activeObj.aCoords.tr.x;
      }
      if (activeObj.angle > 270) {
        left = 0;
      }
      activeObj.set({
        left,
      });
      break;
    case 'right':
      if (activeObj.angle <= 90) {
        left = activeObj.aCoords.tl.x + (window.canvas.width / cZ - activeObj.aCoords.tr.x);
      }
      if (activeObj.angle > 90 && activeObj.angle <= 180) {
        left = window.canvas.width / cZ;
      }
      if (activeObj.angle > 180 && activeObj.angle <= 270) {
        left = activeObj.aCoords.tl.x + (window.canvas.width / cZ - activeObj.aCoords.bl.x);
      }
      if (activeObj.angle > 270) {
        left = activeObj.aCoords.tl.x + (window.canvas.width / cZ - activeObj.aCoords.br.x);
      }
      activeObj.set({
        left,
      });
      break;
    case 'top':
      if (activeObj.angle <= 90) {
        top = 0;
      }
      if (activeObj.angle > 90 && activeObj.angle <= 180) {
        top = activeObj.aCoords.tl.y - activeObj.aCoords.bl.y;
      }
      if (activeObj.angle > 180 && activeObj.angle <= 270) {
        top = activeObj.aCoords.tl.y - activeObj.aCoords.br.y;
      }
      if (activeObj.angle > 270) {
        top = activeObj.aCoords.tl.y - activeObj.aCoords.tr.y;
      }
      activeObj.set({
        top,
      });
      break;
    case 'bottom':
      if (activeObj.angle <= 90) {
        top = activeObj.aCoords.tl.y + (window.canvas.height / cZ - activeObj.aCoords.br.y);
      }
      if (activeObj.angle > 90 && activeObj.angle <= 180) {
        top = activeObj.aCoords.tl.y + (window.canvas.height / cZ - activeObj.aCoords.tr.y);
      }
      if (activeObj.angle > 180 && activeObj.angle <= 270) {
        top = window.canvas.height / cZ;
      }
      if (activeObj.angle > 270) {
        top = activeObj.aCoords.tl.y + (window.canvas.height / cZ - activeObj.aCoords.bl.y);
      }
      activeObj.set({
        top,
      });
      break;
    case 'center':
      activeObj.viewportCenterH();
      break;
    case 'middle':
      activeObj.viewportCenterV();
      break;
    default:
      break;
  }
};
